import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CapitalizePipe } from './capitalize.pipe';
import { ArrayToStringPipe } from './array2string.pipe';
import { TruncatePipe } from './truncate.pipe';
import { AddressPipe } from './address.pipe';
import { FormatDatePipe } from './format-date.pipe';
import { DoubleZeroPipe } from './double-zero.pipe';
@NgModule({
  imports: [CommonModule],
  declarations: [CapitalizePipe, ArrayToStringPipe, TruncatePipe, AddressPipe, FormatDatePipe, DoubleZeroPipe],
  exports: [CapitalizePipe, ArrayToStringPipe, TruncatePipe, AddressPipe, FormatDatePipe, DoubleZeroPipe],
})
export class PipesModule {}
